import { APP_METRIC_KEY } from '@atlassian/jira-software-board-settings-general-common/src/common/constants/analytics.tsx';

export const BOARD_SETTINGS_ARTICLE_ID_GENERAL_BOARD_SUBFILTER_JIRA_SOFTWARE =
	'6fTVqdPXhRETx37NvRHegU';
export const BOARD_SETTINGS_ARTICLE_ID_GENERAL_BOARD_SUBFILTER_ANALYTICS_ID = `${APP_METRIC_KEY}.sub-filter.article.analytics`;
